import * as React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { withCurrentUser } from 'src/components/withCurrentUser';

import { initNewThreadWithUser } from 'src/actions/directMessageThreads';

const InitDirectMessage = props => {
  const { dispatch, history, currentUser, render, user } = props;

  const init = e => {
    e && e.preventDefault() && e.stopPropogation();
    dispatch(initNewThreadWithUser(user));
    history.push({
      pathname: currentUser ? `/new/message` : '/login',
      state: { modal: !!currentUser },
    });
  };

  if (currentUser && currentUser.id === user.id) return null;

  return (
    <span
      data-cy="message-user-button"
      style={{ display: 'flex', flex: '1 0 auto' }}
      onClick={init}
    >
      {render}
    </span>
  );
};

export default compose(
  connect(),
  withCurrentUser,
  withRouter
)(InitDirectMessage);
